import {cn} from 'platform/shared-tw';

import {useTranslation} from 'react-i18next';

import {
  createKeyDownHandler,
  partFill,
  partStroke,
  type DiagramVariant,
} from '../shared/partVariants';

// MIRA-TBD | Target: next design handoff milestone
// Rename this component, its file, and all imports from SomePartA to the confirmed automotive part
// name once design finalises the label.
//
// Acceptance criteria:
//   - Rename SomePartA.tsx → <RealPartName>.tsx
//   - Rename exported function SomePartA → <RealPartName>
//   - Update constants SOME_PART_A_BOTTOM_OFFSET / SOME_PART_A_LEFT_OFFSET to match new name
//   - Update all import sites (EngineView.tsx and any other consumers)
//   - Update SOME_PART_A_LABEL to use the real part name
const SOME_PART_A_BOTTOM_OFFSET = 90;
const SOME_PART_A_LEFT_OFFSET = 164;
const SOME_PART_A_LABEL_KEY = 'ui.carPart.somePartA';

interface SomePartAProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function SomePartA(props: SomePartAProps) {
  const {t} = useTranslation();
  const clickable = Boolean(props.onClick);

  return (
    <svg
      width="34"
      height="62"
      viewBox="0 0 34 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute focus:outline-none focus-visible:outline-none ${clickable ? 'cursor-pointer group' : ''}`}
      style={{bottom: SOME_PART_A_BOTTOM_OFFSET, left: SOME_PART_A_LEFT_OFFSET}}
      onClick={props.onClick}
      onKeyDown={clickable ? createKeyDownHandler(props.onClick) : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-label={clickable ? t(SOME_PART_A_LABEL_KEY) : undefined}
    >
      <path
        d="M23 5C23 5 23 1 19 1H15C11 1 11 5 11 5H5C1 5 1 9 1 9V57C1 57 1 61 5 61H29C33 61 33 57 33 57V9C33 9 33 5 29 5H23Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      />
      <path
        d="M1 9C1 9 1 5 5 5H29C33 5 33 9 33 9V57C33 57 33 61 29 61H5C1 61 1 57 1 57V9Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23 5C23 5 23 1 19 1H15C11 1 11 5 11 5H23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M7 47C7 47 7 45 9 45H21C23 45 23 47 23 47V53C23 53 23 55 21 55H9C7 55 7 53 7 53V47Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
